"use client";

import dynamic from "next/dynamic";

const PersonaBuyButton = dynamic(
  () => import("@/components/blocks/listings/persona-buy-button"),
  {
    ssr: false,
    loading: () => (
      <button
        type="button"
        disabled
        className="inline-flex h-8 items-center justify-center rounded-full bg-primary px-4 text-xs font-semibold text-[#2a1200] opacity-100"
      >
        Buy
      </button>
    ),
  }
);

type DeferredPurchaseButtonProps = {
  productId: string;
  itemName: string;
  price: number;
  className?: string;
};

export default function DeferredPurchaseButton({
  productId,
  itemName,
  price,
  className,
}: DeferredPurchaseButtonProps) {
  return (
    <PersonaBuyButton
      productId={productId}
      itemName={itemName}
      price={price}
      buttonText="Buy"
      uiSource="marketing-home-card"
      size="sm"
      className={className}
    />
  );
}
